import { call, put, takeLatest } from 'redux-saga/effects';

import * as types from './DataCenterAutomationActionType';
import * as actions from './DataCenterAutomationActions';
import * as dataCenterAutomationService from './DataCenterAutomationServices';
import SweetAlert from '../../../components/sweetalert/SweetAlert';

function* exportDocumentMappingSaga(action) {
    try {
        const response = yield call(dataCenterAutomationService.exportDocumentMapping, action.payload);
        if (response && response.data) {
            yield put(actions.exportDocumentMappingSuccess(response.data));
        } else {
            yield put(actions.exportDocumentMappingFailure('No data available for export.'));
        }
    } catch (error) {
        yield put(actions.exportDocumentMappingFailure(error.message || 'Failed to export document mapping.'));
    }
}

function* dataCenterAutomationSaveBulkSaga(action) {
    try {
        const response = yield call(dataCenterAutomationService.dataCenterAutomationSaveBulk, action.payload);
        
        if (response.status || response.data) {
            yield put(actions.dataCenterAutomationSaveBulkSuccess(response.data));
            
            // Show success message with API response message or default
            yield call(() =>
                SweetAlert.success({
                    title: 'Success!',
                    text: response.responseMessage || response.message || 'Data Center Automation initiated successfully',
                    allowOutsideClick: true,
                    allowEscapeKey: true,
                    confirmButtonColor: '#28a745',
                }));
        } else {
            yield put(actions.dataCenterAutomationSaveBulkFailure(response.responseMessage || 'Failed to initiate automation'));
            
            // Show error with API response message
            yield call(() =>
                SweetAlert.error({
                    title: 'Error!',
                    text: response.responseMessage || response.message || 'Failed to initiate data center automation. Please try again.',
                    allowOutsideClick: true,
                    allowEscapeKey: true,
                    confirmButtonColor: '#d33',
                }));
        }
    } catch (error) {
        yield put(actions.dataCenterAutomationSaveBulkFailure(error.message || 'Network error occurred'));
        
        // Handle network/API errors
        yield call(() =>
            SweetAlert.error({
                title: 'Error!',
                text: error.response?.data?.responseMessage || error.response?.data?.message || error.message || 'Network error occurred. Please check your connection and try again.',
                allowOutsideClick: true,
                allowEscapeKey: true,
                confirmButtonColor: '#d33',
            }));
    }
}

function* dataCenterAutomationListSaga(action) {
    try {
        const response = yield call(dataCenterAutomationService.getDataCenterAutomationList, action.payload);
        
        if (response.status && response.data) {
            yield put(actions.dataCenterAutomationListSuccess(response.data));
        } else {
            yield put(actions.dataCenterAutomationListFailure(response.responseMessage || 'Failed to fetch automation list'));
        }
    } catch (error) {
        yield put(actions.dataCenterAutomationListFailure(error.message || 'Network error occurred'));
    }
}

function* documentMappingsSaga(action) {
    try {
        const response = yield call(dataCenterAutomationService.getDocumentMappingsByAutomationID, action.payload);
        
        if (response.status && response.data) {
            yield put(actions.documentMappingsSuccess(response.data));
        } else {
            yield put(actions.documentMappingsFailure(response.responseMessage || 'Failed to fetch document mappings'));
        }
    } catch (error) {
        yield put(actions.documentMappingsFailure(error.message || 'Network error occurred'));
    }
}

function* folderPathTestConnectionSaga(action) {
    try {
        const response = yield call(dataCenterAutomationService.folderPathTestConnection, action.payload);
        
        if (response.status && response.data) {
            yield put(actions.folderPathTestConnectionSuccess(response.data));
        } else {
            yield put(actions.folderPathTestConnectionFailure(response.responseMessage || 'Failed to test connection'));
        }
    } catch (error) {
        yield put(actions.folderPathTestConnectionFailure(error.message || 'Network error occurred'));
    }
}

export default function* watchDataCenterAutomationSaga() {
    yield takeLatest(types.DATA_CENTER_AUTOMATION_SAVE_BULK_REQUEST, dataCenterAutomationSaveBulkSaga);
    yield takeLatest(types.DATA_CENTER_AUTOMATION_LIST_REQUEST, dataCenterAutomationListSaga);
    yield takeLatest(types.DOCUMENT_MAPPINGS_REQUEST, documentMappingsSaga);
    yield takeLatest(types.FOLDER_PATH_TEST_CONNECTION_REQUEST, folderPathTestConnectionSaga);
    yield takeLatest(types.EXPORT_DOCUMENT_MAPPING_REQUEST, exportDocumentMappingSaga);
}
